// extracted by mini-css-extract-plugin
export default {"container":"Scanner_container__SMllW"};